import React from "react";
import { normalizePageTransitionId, STAGGER_PANEL_TRANSITION_IDS } from "./escapeRoomEditorConstants";
import { PAGE_TRANSITION_PREVIEW_CSS, PAGE_TRANSITION_PREVIEW_CYCLE_S } from "./pageTransitionPreviewStyles";

let stylesInjected = false;

function ensurePreviewStyles() {
	if (stylesInjected) return;
	stylesInjected = true;
	const el = document.createElement("style");
	el.setAttribute("data-er-page-transition-preview", "1");
	el.textContent = PAGE_TRANSITION_PREVIEW_CSS;
	document.head.appendChild(el);
}

export default function PageTransitionPreview({ transitionId, playing = false }) {
	const id = normalizePageTransitionId(transitionId || "none");
	const isPanel = STAGGER_PANEL_TRANSITION_IDS.has(id);
	const isGlitch = id === "glitch";
	const isMist = id === "mist";
	const isBuild = id === "build";
	const isClinical = id === "clinical";
	const isFlash = id === "flashExit" || id === "flashEnter" || id === "flashBoth";

	if (typeof document !== "undefined") ensurePreviewStyles();

	return (
		<div
			className={`er-pt-prev${playing ? " er-pt-prev--playing" : ""}`}
			data-id={id}
			style={{ "--er-pt-cycle": `${PAGE_TRANSITION_PREVIEW_CYCLE_S}s` }}
			aria-hidden
		>
			<div className="er-pt-prev__stage">
				<div className="er-pt-prev__page er-pt-prev__page--a">
					<span>1</span>
				</div>
				<div className="er-pt-prev__page er-pt-prev__page--b">
					{isPanel ? (
						<div className="er-pt-prev__panels">
							<div className="er-pt-prev__panel er-pt-prev__panel--1" />
							<div className="er-pt-prev__panel er-pt-prev__panel--2" />
							<div className="er-pt-prev__panel er-pt-prev__panel--3" />
						</div>
					) : (
						<span>2</span>
					)}
				</div>
				{isGlitch ? (
					<div className="er-pt-prev__overlay">
						<div className="er-pt-prev__glitch-band er-pt-prev__glitch-band--a" />
						<div className="er-pt-prev__glitch-band er-pt-prev__glitch-band--b" />
						<div className="er-pt-prev__glitch-band er-pt-prev__glitch-band--c" />
					</div>
				) : null}
				{isMist ? (
					<div className="er-pt-prev__overlay">
						<div className="er-pt-prev__mist-base" />
						<div className="er-pt-prev__mist-wisp er-pt-prev__mist-wisp--a" />
						<div className="er-pt-prev__mist-wisp er-pt-prev__mist-wisp--b" />
					</div>
				) : null}
				{isClinical ? (
					<div className="er-pt-prev__overlay">
						<div className="er-pt-prev__clinical-scan" />
						<svg className="er-pt-prev__clinical-ecg" viewBox="0 0 160 28" preserveAspectRatio="none" aria-hidden>
							<path d="M0,14 L28,14 L34,14 L40,4 L46,24 L52,8 L58,14 L90,14 L96,14 L102,6 L108,22 L114,10 L120,14 L160,14" />
						</svg>
					</div>
				) : null}
				{isBuild ? (
					<div className="er-pt-prev__overlay">
						<div className="er-pt-prev__assembly-guides">
							<span className="er-pt-prev__assembly-corner er-pt-prev__assembly-corner--tl" />
							<span className="er-pt-prev__assembly-corner er-pt-prev__assembly-corner--tr" />
							<span className="er-pt-prev__assembly-corner er-pt-prev__assembly-corner--bl" />
							<span className="er-pt-prev__assembly-corner er-pt-prev__assembly-corner--br" />
						</div>
					</div>
				) : null}
				{isFlash ? <div className="er-pt-prev__flash" /> : null}
			</div>
		</div>
	);
}
